// Import of creatApp from Vue 3 bundler and axios for API requests.
import { createApp } from 'vue/dist/vue.esm-bundler';
import AgendaItem from './components/AgendaItem.vue';
import mixin from '../mixin.js';
import axios from 'axios';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const agendaWidgetApp = {
    components: { AgendaItem },
    mixins: [mixin],
    // The data object returns data-attribute values instantiated in HTML and general properties for loading state 
    // and the data object with facets and resulting items.
    data() {
        return {
            dataApi: '',
            dataLimit: 10, // Default limit in BE
            dataSortKey: '',
            dataSortDirection: '',
            dataEventIds: [],
            dataGenre: '',

            loading: true,
            data: null,
            page: 1,
        }
    },
    // The computed object holds reactive properties for orderItems, filterItems and the queryModel.
    computed: {
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: (this.page - 1) * this.dataLimit,
                OrderItems: this.orderItems,
                FilterItems: [],
            }
        },
    },
    methods: {
        // The fetchData method fetches and handles API data, mainly facets and resulting items. 
        fetchData() {
            let tempQueryModel = { ...this.queryModel };
            if (this.dataEventIds.length) {
                tempQueryModel.FilterItems = [{
                    Key: 'productionProviderId',
                    Values: this.dataEventIds,
                    Operator: 'In',
                }];

                axios
                    .post(this.dataApi, tempQueryModel)
                    .then(response => {
                        if (response.status === 200) {
                            this.data = response.data;
                        }
                    })
                    .then(() => {
                        tempQueryModel = { ...this.queryModel };
                        tempQueryModel.Limit = this.dataLimit - this.data.items.length;
                        if (this.dataGenre) {
                            tempQueryModel.FilterItems = [{
                                Key: 'genres.name',
                                Values: [this.dataGenre],
                                Operator: 'Eq',
                            }];
                        }

                        axios
                            .post(this.dataApi, tempQueryModel)
                            .then(response => {
                                if (response.status === 200) {
                                    if (response.data.items && response.data.items.length) {
                                        response.data.items.forEach(item => {
                                            this.data.items.push(item);
                                        })
                                    }
                                }
                            })
                            .catch(error => console.log(error))
                            .finally(() => this.loading = false);
                    })
                    .catch(error => console.log(error))
            }
            else {
                if (this.dataGenre) {
                    tempQueryModel.FilterItems = [{
                        Key: 'genres.name',
                        Values: [this.dataGenre],
                        Operator: 'Eq',
                    }];
                }

                axios
                    .post(this.dataApi, tempQueryModel)
                    .then(response => {
                        if (response.status === 200) {
                            this.data = response.data;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            }
        },
        setSwiper() {
            const self = this;
            const widgetAgendaSwiper = new Swiper('.widget-agenda .swiper', {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1067: {
                        slidesPerView: 3,
                    },
                    1500: {
                        slidesPerView: 4,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        return `${current} / ${total}`;
                    }
                },
            });
            widgetAgendaSwiper.slidePrev(1, false);
            widgetAgendaSwiper.slideToLoop(0, 0);
        },
        redirect(url) {
            if (url) window.location.href = url;
        },
        // Simple date string handler.
        toDateStr(dateString) {
            let date = new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
            let time = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
            return date.replace('.', '') + ' | ' + time;
        },
        toMediaQuery(mediaString) {
            if (!mediaString) return '';
            return mediaString.split('"')[1];
        },
        reverse(array) {
            return [...array].reverse();
        },
    },
    mounted() {
        // Set data props according to data attributes in HTML template.
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
        if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
        if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
        if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
        if (this.$el.dataset.eventids) this.dataEventIds = this.$el.dataset.eventids.split(',');
        if (this.$el.dataset.genre) this.dataGenre = this.$el.dataset.genre;

        // Initial data fetch.
        this.fetchData();
    },
    updated() {
        this.setSwiper();
    }
};

export default agendaWidgetApp;
